import { defineComponent as _defineComponent } from 'vue'
import { Breadcrumb } from "@/types";
  import { ref, watch } from "vue";
  import { toPreviousPage } from "@/helpers/history";
  import router from "@/router";
  interface Props {
    crumbs: Breadcrumb[];
    backButton: boolean;
    crumbLabel: boolean;
    backButtonPath: string | null;
  }
  
export default /*@__PURE__*/_defineComponent({
  __name: 'Breadcrumbs',
  props: {
    crumbs: { default: () => [] },
    backButton: { type: Boolean, default: false },
    crumbLabel: { type: Boolean, default: true },
    backButtonPath: { default: null }
  },
  emits: ["selected"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const onBack = () => {
    try {
      props.backButtonPath
        ? router.push({ path: props.backButtonPath })
        : toPreviousPage();
    } catch (error) {
      router.push("/");
    }
  };
  const props = __props;
  const emit = __emit;

  const lastChild = ref<Breadcrumb>();

  watch(
    () => props.crumbs,
    () => {
      if (props.crumbs) {
        lastChild.value = props.crumbs.slice(-1)[0];
      }
    },
    { deep: true, immediate: true }
  );

  function isLast(index: number) {
    return index === props.crumbs.length - 1;
  }
  function selected(crumb: Breadcrumb, index: number) {
    emit("selected", crumb);
  }

const __returned__ = { onBack, props, emit, lastChild, isLast, selected, get Breadcrumb() { return Breadcrumb }, ref, watch, get toPreviousPage() { return toPreviousPage }, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})